export default __webpack_public_path__ + "static/media/phoneIcon.ef62bd6f.svg";